
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("eWqok", function(module, exports) {

$parcel$export(module.exports, "getEl", () => $ae0af43c09de0737$export$4f2058fac34d19ff);
$parcel$export(module.exports, "isMobile", () => $ae0af43c09de0737$export$d0a8044dce8ff2fc);
$parcel$export(module.exports, "toggleLoading", () => $ae0af43c09de0737$export$db77633e97f698a6);
$parcel$export(module.exports, "showError", () => $ae0af43c09de0737$export$3879b24e8245693d);
$parcel$export(module.exports, "resetErrors", () => $ae0af43c09de0737$export$16b70c0fc68d4705);
$parcel$export(module.exports, "invalidateFields", () => $ae0af43c09de0737$export$18853433ac336107);
// domCache.js
const $ae0af43c09de0737$var$cache = {};
const $ae0af43c09de0737$var$mobileMQ = window.matchMedia('(max-width: 1024px)');
function $ae0af43c09de0737$export$4f2058fac34d19ff(id) {
    if (!$ae0af43c09de0737$var$cache[id]) $ae0af43c09de0737$var$cache[id] = document.getElementById(id);
    return $ae0af43c09de0737$var$cache[id];
}
function $ae0af43c09de0737$export$d0a8044dce8ff2fc() {
    return $ae0af43c09de0737$var$mobileMQ.matches;
}
function $ae0af43c09de0737$export$d2adf65b87e47523() {
    Object.keys($ae0af43c09de0737$var$cache).forEach((k)=>delete $ae0af43c09de0737$var$cache[k]);
}
function $ae0af43c09de0737$export$db77633e97f698a6(loading) {
    // Disable / enable form fields
    document.querySelectorAll("form input, form select, button").forEach((item)=>{
        if (loading) item.setAttribute('disabled', 'disabled');
        else item.removeAttribute('disabled');
    });
    $ae0af43c09de0737$export$4f2058fac34d19ff('loader').style.display = loading ? 'block' : 'none';
}
function $ae0af43c09de0737$export$3879b24e8245693d(message) {
    let errors = $ae0af43c09de0737$export$4f2058fac34d19ff('errors');
    let error = document.createElement('div');
    error.textContent = message;
    error.setAttribute('role', 'alert');
    errors.appendChild(error);
}
function $ae0af43c09de0737$export$16b70c0fc68d4705() {
    let errors = $ae0af43c09de0737$export$4f2058fac34d19ff('errors');
    while(errors.firstChild)errors.removeChild(errors.firstChild);
}
function $ae0af43c09de0737$export$18853433ac336107(errors) {
    // Clear previous error states
    document.querySelectorAll('[aria-invalid="true"]').forEach((el)=>{
        el.removeAttribute('aria-invalid');
    });
    $ae0af43c09de0737$export$16b70c0fc68d4705();
    // Apply new ones
    Object.entries(errors).forEach(([field, message])=>{
        const el = $ae0af43c09de0737$export$4f2058fac34d19ff(field);
        if (!el) return;
        el.setAttribute('aria-invalid', 'true');
        if (message.length > 0) $ae0af43c09de0737$export$3879b24e8245693d(message);
    });
}

});

parcelRegister("g4wOo", function(module, exports) {

$parcel$export(module.exports, "PALETTES", () => $bb3678cc55639288$export$d9e1028cbc2a33d);
$parcel$export(module.exports, "setupPalette", () => $bb3678cc55639288$export$536d02a0bbeee7e1);

var $eWqok = parcelRequire("eWqok");

var $lvhTS = parcelRequire("lvhTS");

var $ifgZ7 = parcelRequire("ifgZ7");

var $5Z3SY = parcelRequire("5Z3SY");
const $bb3678cc55639288$export$d9e1028cbc2a33d = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($5Z3SY))));
function $bb3678cc55639288$export$536d02a0bbeee7e1() {
    // Setup palette modal
    const paletteTemplate = (0, $eWqok.getEl)('paletteModalTemplate').innerHTML;
    (0, $eWqok.getEl)('modalTarget').innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($ifgZ7))).render(paletteTemplate, $bb3678cc55639288$export$d9e1028cbc2a33d);
    document.querySelectorAll('#paletteModal li').forEach((item)=>{
        item.addEventListener('click', ()=>{
            let paletteDom = (0, $eWqok.getEl)('palette');
            paletteDom.value = item.getAttribute('data-index');
            paletteDom.dispatchEvent(new Event("change"));
            (0, $lvhTS.closeModal)((0, $lvhTS.visibleModal));
        }, false);
    });
    // Add palettes to dropdown
    if ((0, $eWqok.getEl)("palette")) for (let x of $bb3678cc55639288$export$d9e1028cbc2a33d.palettes){
        if (x.index == 12) continue;
        var sel = document.createElement("option");
        sel.innerHTML = x.name;
        sel.value = x.index;
        (0, $eWqok.getEl)("palette").appendChild(sel);
    }
}

});
parcelRegister("lvhTS", function(module, exports) {

$parcel$export(module.exports, "visibleModal", () => $fa7a60d60ed0fb7b$export$56f7a2e37de38a61);
$parcel$export(module.exports, "toggleModal", () => $fa7a60d60ed0fb7b$export$313c6d35f75fc0e);
$parcel$export(module.exports, "closeModal", () => $fa7a60d60ed0fb7b$export$3f6fecd573f3fa48);
/*
 * Modal
 *
 * Pico.css - https://picocss.com
 * Copyright 2019-2024 - Licensed under MIT
 */ // Config
const $fa7a60d60ed0fb7b$var$isOpenClass = "modal-is-open";
const $fa7a60d60ed0fb7b$var$openingClass = "modal-is-opening";
const $fa7a60d60ed0fb7b$var$closingClass = "modal-is-closing";
const $fa7a60d60ed0fb7b$var$scrollbarWidthCssVar = "--pico-scrollbar-width";
const $fa7a60d60ed0fb7b$var$animationDuration = 400; // ms
let $fa7a60d60ed0fb7b$export$56f7a2e37de38a61 = null;
const $fa7a60d60ed0fb7b$export$313c6d35f75fc0e = (event)=>{
    event.preventDefault();
    const modal = document.getElementById(event.currentTarget.dataset.target);
    if (!modal) return;
    modal && (modal.open ? $fa7a60d60ed0fb7b$export$3f6fecd573f3fa48(modal) : $fa7a60d60ed0fb7b$var$openModal(modal));
};
// Open modal
const $fa7a60d60ed0fb7b$var$openModal = (modal)=>{
    const { documentElement: html } = document;
    const scrollbarWidth = $fa7a60d60ed0fb7b$var$getScrollbarWidth();
    if (scrollbarWidth) html.style.setProperty($fa7a60d60ed0fb7b$var$scrollbarWidthCssVar, `${scrollbarWidth}px`);
    html.classList.add($fa7a60d60ed0fb7b$var$isOpenClass, $fa7a60d60ed0fb7b$var$openingClass);
    setTimeout(()=>{
        $fa7a60d60ed0fb7b$export$56f7a2e37de38a61 = modal;
        html.classList.remove($fa7a60d60ed0fb7b$var$openingClass);
    }, $fa7a60d60ed0fb7b$var$animationDuration);
    modal.showModal();
};
const $fa7a60d60ed0fb7b$export$3f6fecd573f3fa48 = (modal)=>{
    $fa7a60d60ed0fb7b$export$56f7a2e37de38a61 = null;
    const { documentElement: html } = document;
    html.classList.add($fa7a60d60ed0fb7b$var$closingClass);
    setTimeout(()=>{
        html.classList.remove($fa7a60d60ed0fb7b$var$closingClass, $fa7a60d60ed0fb7b$var$isOpenClass);
        html.style.removeProperty($fa7a60d60ed0fb7b$var$scrollbarWidthCssVar);
        modal.close();
    }, $fa7a60d60ed0fb7b$var$animationDuration);
};
// Close with a click outside
document.addEventListener("click", (event)=>{
    if ($fa7a60d60ed0fb7b$export$56f7a2e37de38a61 === null) return;
    const modalContent = $fa7a60d60ed0fb7b$export$56f7a2e37de38a61.querySelector("article");
    const isClickInside = modalContent.contains(event.target);
    !isClickInside && $fa7a60d60ed0fb7b$export$3f6fecd573f3fa48($fa7a60d60ed0fb7b$export$56f7a2e37de38a61);
});
// Close with Esc key
document.addEventListener("keydown", (event)=>{
    if (event.key === "Escape" && $fa7a60d60ed0fb7b$export$56f7a2e37de38a61) $fa7a60d60ed0fb7b$export$3f6fecd573f3fa48($fa7a60d60ed0fb7b$export$56f7a2e37de38a61);
});
// Get scrollbar width
const $fa7a60d60ed0fb7b$var$getScrollbarWidth = ()=>{
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return scrollbarWidth;
};
// Is scrollbar visible
const $fa7a60d60ed0fb7b$var$isScrollbarVisible = ()=>{
    return document.body.scrollHeight > screen.height;
};

});

parcelRegister("ifgZ7", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === '[object Array]';
    };
    function isFunction(object) {
        return typeof object === 'function';
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? 'array' : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === 'object' && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== 'object' && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ''; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === 'string') tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error('Invalid tags: ' + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
            closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += ' ';
                }
                tokens.push([
                    'text',
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === '\n') {
                    stripSpace();
                    indentation = '';
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || 'name';
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === '=') {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === '{') {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = '&';
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error('Unclosed tag at ' + scanner.pos);
            if (type == '>') token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === '#' || type === '^') sections.push(token);
            else if (type === '/') {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === 'name' || type === '{' || type === '&') nonSpace = true;
            else if (type === '=') // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case '#':
                case '^':
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case '/':
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === '';
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return '';
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = '';
                break;
            case 0:
                match = '';
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            '.': this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf('.') > 0) {
                    intermediateValue = context.view;
                    names = name.split('.');
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== 'undefined') this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ':' + (tags || mustache.tags).join(':');
        var isCacheEnabled = typeof cache1 !== 'undefined';
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = '';
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === '>') value = this.renderPartial(token, context, partials, config);
            else if (symbol === '&') value = this.unescapedValue(token, context);
            else if (symbol === 'name') value = this.escapedValue(token, context, config);
            else if (symbol === 'text') value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = '';
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== 'string') throw new Error('Cannot use higher-order sections without the original template');
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, '');
        var partialByNl = partial.split('\n');
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join('\n');
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === 'number' && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === 'object') return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === 'object' && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: 'mustache.js',
        version: '4.2.0',
        tags: [
            '{{',
            '}}'
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== 'string') throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + 'argument for mustache#render(template, view, partials)');
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});

});

parcelRegister("5Z3SY", function(module, exports) {
module.exports = "{\n  \"palettes\": [\n    {\n      \"index\": 0,\n      \"name\": \"Sour Candy\",\n      \"colors\": [\n        \"#88CBA0\",\n        \"#88C670\",\n        \"#92C94C\",\n        \"#B5D557\",\n        \"#DDE65E\",\n        \"#FCEA60\",\n        \"#FBB564\",\n        \"#F38064\",\n        \"#F25F79\",\n        \"#F061A4\"\n      ]\n    },\n    {\n      \"index\": 1,\n      \"name\": \"Frankensteined\",\n      \"colors\": [\n        \"#110015\",\n        \"#3d192d\",\n        \"#a3306f\",\n        \"#75108b\",\n        \"#6e39b8\",\n        \"#ff7037\",\n        \"#ff9b3e\",\n        \"#aba803\",\n        \"#b8d14b\",\n        \"#fef4f1\"\n      ]\n    },\n    {\n      \"index\": 2,\n      \"name\": \"Somewhere Over The Rainbow\",\n      \"colors\": [\n        \"#F11C29\",\n        \"#F6871F\",\n        \"#FED307\",\n        \"#DAE123\",\n        \"#ADD032\",\n        \"#6FC385\",\n        \"#69CDE3\",\n        \"#4375BA\",\n        \"#5853A2\",\n        \"#8D549F\"\n      ]\n    },\n    {\n      \"index\": 3,\n      \"name\": \"Warmer Than Fire\",\n      \"colors\": [\n        \"#ffbc12\",\n        \"#F69F1E\",\n        \"#EC7E22\",\n        \"#F15A23\",\n        \"#EF3725\",\n        \"#EE2237\",\n        \"#EE0E6A\",\n        \"#E1068C\",\n        \"#C13C97\",\n        \"#93509F\"\n      ]\n    },\n    {\n      \"index\": 4,\n      \"name\": \"Under The Sea\",\n      \"colors\": [\n        \"#184e77\",\n        \"#1e6091\",\n        \"#1a759f\",\n        \"#168aad\",\n        \"#34a0a4\",\n        \"#52b69a\",\n        \"#76c893\",\n        \"#99d98c\",\n        \"#b5e48c\",\n        \"#d9ed92\"\n      ]\n    },\n    {\n      \"index\": 5,\n      \"name\": \"Pink Pony Club\",\n      \"colors\": [\n        \"#f15e90\",\n        \"#f686ab\",\n        \"#f9a5c1\",\n        \"#f7ebed\",\n        \"#eb8c38\",\n        \"#e35555\",\n        \"#f9c3d7\",\n        \"#f497b6\",\n        \"#bb78ae\",\n        \"#844780\"\n      ]\n    },\n    {\n      \"index\": 6,\n      \"name\": \"Duga je noć (It's a long night)\",\n      \"colors\": [\n        \"#1f00ab\",\n        \"#4a00ab\",\n        \"#5f00a8\",\n        \"#7000a8\",\n        \"#7b00a1\",\n        \"#82009a\",\n        \"#920092\",\n        \"#9a0080\",\n        \"#a10073\",\n        \"#a8005f\"\n      ]\n    },\n    {\n      \"index\": 7,\n      \"name\": \"Monochrome Kiss\",\n      \"colors\": [\n        \"#000000\",\n        \"#1c1c1c\",\n        \"#393939\",\n        \"#555555\",\n        \"#717171\",\n        \"#8e8e8e\",\n        \"#aaaaaa\",\n        \"#c6c6c6\",\n        \"#e3e3e3\",\n        \"#ffffff\"\n      ]\n    },\n    {\n      \"index\": 8,\n      \"name\": \"Just like Heaven\",\n      \"colors\": [\n        \"#3592a3\",\n        \"#56a5bb\",\n        \"#97c3d9\",\n        \"#8499c2\",\n        \"#b19dc6\",\n        \"#ccc0d6\",\n        \"#c1c4d5\",\n        \"#b4cbdd\",\n        \"#aed2e0\"\n      ]\n    },\n    {\n      \"index\": 9,\n      \"name\": \"Chainsaws In Paradise\",\n      \"colors\": [\n        \"#06050c\",\n        \"#053354\",\n        \"#0b4170\",\n        \"#be1a36\",\n        \"#831731\",\n        \"#47050f\",\n        \"#2b0c18\",\n        \"#868b99\"\n      ]\n    },\n    {\n      \"index\": 10,\n      \"name\": \"brat\",\n      \"colors\": [\n        \"#8ACE00\",\n        \"#000000\",\n        \"#8ACE00\",\n        \"#ffffff\"\n      ]\n    },\n    {\n      \"index\": 11,\n      \"name\": \"Watermelon Sugar\",\n      \"colors\": [\n        \"#194227\",\n        \"#0d6d2f\",\n        \"#009736\",\n        \"#f5f5f5\",\n        \"#ee2a35\",\n        \"#e32d37\",\n        \"#d82f38\",\n        \"#bb2c33\",\n        \"#141414\"\n      ]\n    },\n    {\n      \"index\": 12,\n      \"name\": \"LDN\",\n      \"colors\": [\n        \"#dc241f\",\n        \"#ffd329\",\n        \"#007d32\",\n        \"#f4a9be\",\n        \"#a1a5a7\",\n        \"#b26300\",\n        \"#9b0058\",\n        \"#000000\",\n        \"#0019a8\",\n        \"#0098d8\",\n        \"#93ceba\",\n        \"#f1ab00\",\n        \"#773dbd\",\n        \"#b727bf\",\n        \"#00afad\",\n        \"#ef7b10\",\n        \"#00a0e2\",\n        \"#8480d7\",\n        \"#00bd19\",\n        \"#283d86\"\n      ]\n    }\n  ]\n}";

});


parcelRegister("lf7DK", function(module, exports) {




module.exports = {
    "downloadhelper": ()=>(parcelRequire("45nXJ")),
    "piechart": ()=>(parcelRequire("drTia")),
    "receipt": ()=>(parcelRequire("kpcfw")),
    "underground": ()=>(parcelRequire("552og"))
};

});
parcelRegister("45nXJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bu50n").then(()=>parcelRequire('klgEo'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("drTia", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("bu50n"),
    $Gr8vk("kxxVZ")
]).then(()=>parcelRequire('1EzBs'));

});

parcelRegister("kpcfw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("bu50n"),
    $Gr8vk("juWxV")
]).then(()=>parcelRequire('62dLS'));

});

parcelRegister("552og", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("bu50n"),
    $Gr8vk("g2RJo")
]).then(()=>parcelRequire('bwGaU'));

});


var $d49999099264639a$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"g3LtT\",\"index.744589b5.js\",\"bu50n\",\"downloadhelper.bc204a3b.js\",\"kxxVZ\",\"piechart.96720dac.js\",\"juWxV\",\"receipt.b1d3e7bc.js\",\"g2RJo\",\"underground.289fe449.js\",\"gmWS6\",\"RobotoCondensed-Light.a31380a2.ttf\",\"3jXda\",\"Railway.8fda91a1.ttf\",\"1Sa9l\",\"lobster-stamp.501387ff.png\"]"));


var $eWqok = parcelRequire("eWqok");
const $480eb26aa317c74a$var$USERNAME_REGEX = /^[A-Za-z0-9-_]+$/;
const $480eb26aa317c74a$var$USERNAME_MAX = 15;
const $480eb26aa317c74a$var$USERNAME_MIN = 2;
const $480eb26aa317c74a$var$VALID_PERIODS = [
    '0',
    '1',
    '3',
    '6',
    '12'
];
const $480eb26aa317c74a$var$VALID_DATA = [
    'artists',
    'tracks'
];
const $480eb26aa317c74a$var$USEROPTS = [
    'username',
    'data',
    'period',
    'palette',
    'showUsername',
    'minimizeVA',
    'platform',
    'useInternationalFont'
];
function $480eb26aa317c74a$export$c39d60ad3836980e() {
    let userOpts = {};
    let username = (0, $eWqok.getEl)('username');
    if (username) userOpts.username = username.value;
    let period = (0, $eWqok.getEl)('period');
    if (period) userOpts.period = period.value;
    let data = document.querySelector('input[name="data"]:checked');
    if (data) userOpts.data = data.value;
    let palette = (0, $eWqok.getEl)('palette');
    if (palette) userOpts.palette = palette.value;
    let showUsername = (0, $eWqok.getEl)('showUsername');
    if (showUsername) userOpts.showUsername = showUsername.checked ? true : false;
    let useInternationalFont = (0, $eWqok.getEl)('useInternationalFont');
    if (useInternationalFont) userOpts.useInternationalFont = useInternationalFont.checked ? true : false;
    let minimizeVA = (0, $eWqok.getEl)('minimizeVA');
    if (minimizeVA) userOpts.minimizeVA = minimizeVA.checked ? true : false;
    let platform = (0, $eWqok.getEl)('platform');
    if (platform) userOpts.platform = platform.value;
    return userOpts;
}
function $480eb26aa317c74a$export$d063a043038816d5(options) {
    let username = (0, $eWqok.getEl)('username');
    if (username && typeof options.username !== 'undefined') username.value = options.username;
    let period = (0, $eWqok.getEl)('period');
    if (period && typeof options.period !== 'undefined') period.value = options.period;
    let data = document.querySelector('input[name="data"]');
    if (data && typeof options.data !== 'undefined') data.setAttribute('checked', options.data);
    let palette = (0, $eWqok.getEl)('palette');
    if (palette && typeof options.palette !== 'undefined') palette.value = options.palette;
    let showUsername = (0, $eWqok.getEl)('showUsername');
    if (showUsername && typeof options.showUsername !== 'undefined') showUsername.checked = options.showUsername;
    let useInternationalFont = (0, $eWqok.getEl)('useInternationalFont');
    if (useInternationalFont && typeof options.useInternationalFont !== 'undefined') useInternationalFont.checked = options.useInternationalFont;
    let minimizeVA = (0, $eWqok.getEl)('minimizeVA');
    if (minimizeVA && typeof options.minimizeVA !== 'undefined') minimizeVA.checked = options.minimizeVA;
    let platform = (0, $eWqok.getEl)('platform');
    if (platform && typeof options.platform !== 'undefined') platform.value = options.platform;
}
function $480eb26aa317c74a$export$5f3afe997a31b314() {
    let cookieValue = document.cookie.match('(^|;)\\s*options\\s*=\\s*([^;]+)')?.pop() || '';
    if (cookieValue) {
        if (cookieValue.startsWith('%')) cookieValue = decodeURIComponent(cookieValue);
        return $480eb26aa317c74a$var$scrubOptions(JSON.parse(cookieValue));
    }
    return null;
}
function $480eb26aa317c74a$export$57da33ee5a3f2b7e(options) {
    let existingOptions = $480eb26aa317c74a$export$5f3afe997a31b314();
    let newOptions = options;
    if (existingOptions) newOptions = Object.assign(existingOptions, newOptions);
    document.cookie = "options=" + encodeURIComponent(JSON.stringify($480eb26aa317c74a$var$scrubOptions(newOptions))) + "; max-age: 31536000; path=/";
}
function $480eb26aa317c74a$export$b43e45590305ffaa() {
    document.cookie = "options=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
}
function $480eb26aa317c74a$var$scrubOptions(options) {
    Object.entries(options).forEach(([field])=>{
        if (!$480eb26aa317c74a$var$USEROPTS.includes(field)) delete options[field];
    });
    return options;
}
function $480eb26aa317c74a$export$21565defcc82432b(options) {
    const errors = {};
    if (options.username.length == 0) errors.username = '';
    else // Validate Username
    if (options.username.length > $480eb26aa317c74a$var$USERNAME_MAX || options.username.length < $480eb26aa317c74a$var$USERNAME_MIN || !$480eb26aa317c74a$var$USERNAME_REGEX.test(options.username)) errors.username = 'Invalid username.';
    if (options.period && !$480eb26aa317c74a$var$VALID_PERIODS.includes(options.period)) errors.period = 'No valid timeframe selected';
    if (options.data && !$480eb26aa317c74a$var$VALID_DATA.includes(options.data)) errors.data = 'No valid data selected.';
    return errors;
}



var $eWqok = parcelRequire("eWqok");

var $lvhTS = parcelRequire("lvhTS");

var $g4wOo = parcelRequire("g4wOo");

var $eWqok = parcelRequire("eWqok");
var $27639989c59a0701$exports = {};
$27639989c59a0701$exports = "{\n  \"recommendations\": {\n    \"level1\": {\n      \"text\": \"Thank you for using MusiPie! The algorithm detected a distinct lack of Luke Black in your streaming history. He's a fantastically talented, independent dark alt-pop artist and it would make my day if you checked out his music!\",\n      \"embed\": {\n        \"attributes\": [\n          {\n            \"key\": \"src\",\n            \"value\": \"https://open.spotify.com/embed/artist/3sPiEqLcANa5kAp5RnEHNq?utm_source=generator&theme=0\"\n          },\n          {\n            \"key\": \"id\",\n            \"value\": \"spotify\"\n          },\n          {\n            \"key\": \"width\",\n            \"value\": \"100%\"\n          },\n          {\n            \"key\": \"height\",\n            \"value\": \"352\"\n          },\n          {\n            \"key\": \"frameborder\",\n            \"value\": \"0\"\n          },\n          {\n            \"key\": \"allow\",\n            \"value\": \"autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture\"\n          },\n          {\n            \"key\": \"loading\",\n            \"value\": \"lazy\"\n          }\n        ]\n      }\n    },\n    \"level2\": {\n      \"text\": \"Looks like you also listen to my favourite artist Luke Black! Did you know he has a new single out? Check it out:\",\n      \"embed\": {\n        \"attributes\": [\n          {\n            \"key\": \"src\",\n            \"value\": \"https://open.spotify.com/embed/track/0tlBrMc3bTrV7Xa3lXyXWT?utm_source=generator\"\n          },\n          {\n            \"key\": \"id\",\n            \"value\": \"spotify\"\n          },\n          {\n            \"key\": \"width\",\n            \"value\": \"100%\"\n          },\n          {\n            \"key\": \"height\",\n            \"value\": \"352\"\n          },\n          {\n            \"key\": \"frameborder\",\n            \"value\": \"0\"\n          },\n          {\n            \"key\": \"allow\",\n            \"value\": \"autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture\"\n          },\n          {\n            \"key\": \"loading\",\n            \"value\": \"lazy\"\n          }\n        ]\n      }\n    },\n    \"level3\": {\n      \"text\": \"Thank you for using MusiPie! Looks like you also listen to my favourite artist Luke Black - keep streaming! But did you know that you can support independent artists by buying their music on <a href='https://lukeblackmusic.bandcamp.com' data-umami-event='Bandcamp link'>Bandcamp</a>? You get to keep their music in high quality forever and they get paid fairly for it.\",\n      \"embed\": {\n        \"attributes\": [\n          {\n            \"key\": \"src\",\n            \"value\": \"https://bandcamp.com/EmbeddedPlayer/album=1877015397/size=large/bgcol=333333/linkcol=ffffff/transparent=true/tracklist=false/\"\n          },\n          {\n            \"key\": \"id\",\n            \"value\": \"bandcamp\"\n          },\n          {\n            \"key\": \"seamless\"\n          }\n        ]\n      }\n    },\n    \"level4\": {\n      \"text\": \"Hello fellow lobstie! Thank you for using MusiPie. I have nothing left to teach you. Have a cookie! 🍪\"\n    },\n    \"spotify\": {\n      \"text\": \"Thank you for using MusiPie! While you're here, may I introduce you to Luke Black? He's a fantastically talented, independent dark alt-pop artist and it would make my day if you checked out his music!\",\n      \"embed\": {\n        \"attributes\": [\n          {\n            \"key\": \"src\",\n            \"value\": \"https://open.spotify.com/embed/artist/3sPiEqLcANa5kAp5RnEHNq?utm_source=generator&theme=0\"\n          },\n          {\n            \"key\": \"id\",\n            \"value\": \"spotify\"\n          },\n          {\n            \"key\": \"width\",\n            \"value\": \"100%\"\n          },\n          {\n            \"key\": \"height\",\n            \"value\": \"352\"\n          },\n          {\n            \"key\": \"frameborder\",\n            \"value\": \"0\"\n          },\n          {\n            \"key\": \"allow\",\n            \"value\": \"autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture\"\n          },\n          {\n            \"key\": \"loading\",\n            \"value\": \"lazy\"\n          }\n        ]\n      }\n    },\n    \"apple\": {\n      \"text\": \"Thank you for using MusiPie! While you're here, may I introduce you to Luke Black? He's a fantastically talented, independent dark alt-pop artist and it would make my day if you checked out his music!\",\n      \"embed\": {\n        \"attributes\": [\n          {\n            \"key\": \"src\",\n            \"value\": \"https://embed.music.apple.com/us/album/chainsaws-in-paradise/1739423040\"\n          },\n          {\n            \"key\": \"id\",\n            \"value\": \"apple\"\n          },\n          {\n            \"key\": \"style\",\n            \"value\": \"width:100%;max-width:660px;overflow:hidden;border-radius:10px;\"\n          },\n          {\n            \"key\": \"height\",\n            \"value\": \"450\"\n          },\n          {\n            \"key\": \"frameborder\",\n            \"value\": \"0\"\n          },\n          {\n            \"key\": \"allow\",\n            \"value\": \"autoplay *; encrypted-media *; fullscreen *; clipboard-write\"\n          },\n          {\n            \"key\": \"sandbox\",\n            \"value\": \"allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation\"\n          }\n        ]\n      }\n    },\n    \"youtube\": {\n      \"text\": \"Thank you for using MusiPie! While you're here, may I introduce you to Luke Black? He's a fantastically talented, independent dark alt-pop artist and it would make my day if you checked out his music!\",\n      \"embed\": {\n        \"attributes\": [\n          {\n            \"key\": \"src\",\n            \"value\": \"https://www.youtube.com/embed/videoseries?si=Um28U0eN5nVG66Iy&amp;list=OLAK5uy_kCKko8jholFhO7UTORmSrL-N11lAiSjck\"\n          },\n          {\n            \"key\": \"id\",\n            \"value\": \"youtube\"\n          },\n          {\n            \"key\": \"frameborder\",\n            \"value\": \"0\"\n          },\n          {\n            \"key\": \"allow\",\n            \"value\": \"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\"\n          },\n          {\n            \"key\": \"referrerpolicy\",\n            \"value\": \"strict-origin-when-cross-origin\"\n          }\n        ]\n      }\n    },\n    \"amazon\": {\n      \"text\": \"Thank you for using MusiPie! While you're here, may I introduce you to Luke Black? He's a fantastically talented, independent dark alt-pop artist and it would make my day if you checked out his music!\",\n      \"embed\": {\n        \"attributes\": [\n          {\n            \"key\": \"src\",\n            \"value\": \"https://music.amazon.de/embed/B0064GS31C/?id=oFJwpxnAjj&marketplaceId=A1PA6795UKMFR9&musicTerritory=DE\"\n          },\n          {\n            \"key\": \"id\",\n            \"value\": \"amazon\"\n          },\n          {\n            \"key\": \"frameborder\",\n            \"value\": \"0\"\n          },\n          {\n            \"key\": \"style\",\n            \"value\": \"border-radius: 20px;\"\n          },\n          {\n            \"key\": \"width\",\n            \"value\": \"100%\"\n          },\n          {\n            \"key\": \"height\",\n            \"value\": \"352\"\n          }\n        ]\n      }\n    },\n    \"tidal\": {\n      \"text\": \"Thank you for using MusiPie! While you're here, may I introduce you to Luke Black? He's a fantastically talented, independent dark alt-pop artist and it would make my day if you checked out his music!\",\n      \"embed\": {\n        \"attributes\": [\n          {\n            \"key\": \"src\",\n            \"value\": \"https://embed.tidal.com/albums/355218220?layout=gridify&disableAnalytics=true\"\n          },\n          {\n            \"key\": \"id\",\n            \"value\": \"tidal\"\n          },\n          {\n            \"key\": \"frameborder\",\n            \"value\": \"0\"\n          },\n          {\n            \"key\": \"allow\",\n            \"value\": \"encrypted-media\"\n          },\n          {\n            \"key\": \"allowfullscreen\",\n            \"value\": \"allowfullscreen\"\n          },\n          {\n            \"key\": \"style\",\n            \"value\": \"max-width: 100%; height: 300px;\"\n          }\n        ]\n      }\n    },\n    \"deezer\": {\n      \"text\": \"Thank you for using MusiPie! While you're here, may I introduce you to Luke Black? He's a fantastically talented, independent dark alt-pop artist and it would make my day if you checked out his music!\",\n      \"embed\": {\n        \"attributes\": [\n          {\n            \"key\": \"src\",\n            \"value\": \"https://widget.deezer.com/widget/dark/album/568776601\"\n          },\n          {\n            \"key\": \"id\",\n            \"value\": \"deezer\"\n          },\n          {\n            \"key\": \"frameborder\",\n            \"value\": \"0\"\n          },\n          {\n            \"key\": \"style\",\n            \"value\": \"border-radius: 20px;\"\n          },\n          {\n            \"key\": \"width\",\n            \"value\": \"100%\"\n          },\n          {\n            \"key\": \"height\",\n            \"value\": \"300\"\n          },\n          {\n            \"key\": \"allow\",\n            \"value\": \"encrypted-media; clipboard-write\"\n          },\n          {\n            \"key\": \" allowtransparency\",\n            \"value\": \"true\"\n          }\n        ]\n      }\n    }\n  }\n}";



var $ifgZ7 = parcelRequire("ifgZ7");
const $ce69c7c7f1b67752$export$818c2aa84d295ab0 = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($27639989c59a0701$exports))));
let $ce69c7c7f1b67752$var$recommendationTemplate;
function $ce69c7c7f1b67752$export$f8d9bf6a7c6cbe5f() {
    $ce69c7c7f1b67752$var$recommendationTemplate = (0, $eWqok.getEl)('recommendationTemplate').innerHTML;
    (0, (/*@__PURE__*/$parcel$interopDefault($ifgZ7))).parse($ce69c7c7f1b67752$var$recommendationTemplate);
}
function $ce69c7c7f1b67752$export$88581142a70e5f2a(key) {
    if (key !== undefined && $ce69c7c7f1b67752$export$818c2aa84d295ab0.recommendations[key] !== undefined) {
        (0, $eWqok.getEl)('rec').innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($ifgZ7))).render($ce69c7c7f1b67752$var$recommendationTemplate, $ce69c7c7f1b67752$export$818c2aa84d295ab0.recommendations[key]);
        (0, $eWqok.getEl)('rec').className = 'fadeIn';
    }
}



var $eWqok = parcelRequire("eWqok");
// p5 SceneManager helps you create p5.js sketches with multiple states / scenes
// Each scene is a like a sketch within the main sketch. You focus on creating
// the scene like a regular sketch and SceneManager ensure scene switching
// routing the main setup(), draw(), mousePressed(), etc. events to the 
// appropriate current scene.
//
// Author: Marian Veteanu
// http://github.com/mveteanu
//
// eslint-disable-next-line no-unused-vars
class $7db3033d8052fb9b$export$39927d6faa7131bb {
    constructor(p){
        this.scenes = [];
        this.scene = null;
        // Wire relevant p5.js events, except setup()
        // If you don't call this method, you need to manually wire events
        this.wire = function() {
            const P5Events = [
                'mouseClicked',
                'mousePressed',
                'mouseReleased',
                'mouseMoved',
                'mouseDragged',
                'doubleClicked',
                'mouseWheel',
                'keyPressed',
                'keyReleased',
                'keyTyped',
                'touchStarted',
                'touchMoved',
                'touchEnded',
                'deviceMoved',
                'deviceTurned',
                'deviceShaken'
            ];
            var me = this;
            var o = p != null ? p : window;
            // Wire draw manually for speed reasons...
            o.draw = function() {
                me.draw();
            };
            // This loop will wire automatically all P5 events to each scene like this:
            // o.mouseClicked = function() { me.handleEvent("mouseClicked"); }
            for(var i = 0; i < P5Events.length; i++){
                let sEvent = P5Events[i]; // let is necesary to set the scope at the level of for
                o[sEvent] = function(eventParam) {
                    me.handleEvent(sEvent, eventParam);
                };
            }
            return me;
        };
        // Add a scene to the collection
        // You need to add all the scenes if intend to call .showNextScene()
        this.addScene = function(fnScene) {
            var oScene = new fnScene(p);
            // inject p as a property of the scene
            this.p = p;
            // inject sceneManager as a property of the scene
            oScene.sceneManager = this;
            var o = {
                fnScene: fnScene,
                oScene: oScene,
                hasSetup: 'setup' in oScene,
                hasEnter: 'enter' in oScene,
                hasDraw: 'draw' in oScene,
                setupExecuted: false,
                enterExecuted: false
            };
            this.scenes.push(o);
            return o;
        };
        // Return the index of a scene in the internal collection
        this.findSceneIndex = function(fnScene) {
            for(var i = 0; i < this.scenes.length; i++){
                var o = this.scenes[i];
                if (o.fnScene == fnScene) return i;
            }
            return -1;
        };
        // Return a scene object wrapper
        this.findScene = function(fnScene) {
            var i = this.findSceneIndex(fnScene);
            return i >= 0 ? this.scenes[i] : null;
        };
        // Returns true if the current displayed scene is fnScene
        this.isCurrent = function(fnScene) {
            if (this.scene == null) return false;
            return this.scene.fnScene == fnScene;
        };
        // Show a scene based on the function name
        // Optionally you can send arguments to the scene
        // Arguments will be retrieved in the scene via .sceneArgs property
        this.showScene = function(fnScene, sceneArgs) {
            var o = this.findScene(fnScene);
            if (o == null) o = this.addScene(fnScene);
            // Re-arm the enter function at each show of the scene
            o.enterExecuted = false;
            this.scene = o;
            // inject sceneArgs as a property of the scene
            o.oScene.sceneArgs = sceneArgs;
        };
        // Show the next scene in the collection
        // Useful if implementing demo applications 
        // where you want to advance scenes automatically
        this.showNextScene = function(sceneArgs) {
            if (this.scenes.length == 0) return;
            var nextSceneIndex = 0;
            if (this.scene != null) {
                // search current scene... 
                // can be optimized to avoid searching current scene...
                var i = this.findSceneIndex(this.scene.fnScene);
                nextSceneIndex = i < this.scenes.length - 1 ? i + 1 : 0;
            }
            var nextScene = this.scenes[nextSceneIndex];
            this.showScene(nextScene.fnScene, sceneArgs);
        };
        // This is the SceneManager .draw() method
        // This will dispatch the main draw() to the 
        // current scene draw() method
        this.draw = function() {
            // take the current scene in a variable to protect it in case
            // it gets changed by the user code in the events such as setup()...
            var currScene = this.scene;
            if (currScene == null) return;
            if (currScene.hasSetup && !currScene.setupExecuted) {
                currScene.oScene.setup();
                currScene.setupExecuted = true;
            }
            if (currScene.hasEnter && !currScene.enterExecuted) {
                currScene.oScene.enter();
                currScene.enterExecuted = true;
            }
            if (currScene.hasDraw) currScene.oScene.draw();
        };
        // Handle a certain event for a scene... 
        // It is used by the anonymous functions from the wire() function
        this.handleEvent = function(sEvent, eventParam) {
            if (this.scene == null || this.scene.oScene == null) return;
            var fnSceneEvent = this.scene.oScene[sEvent];
            if (fnSceneEvent) fnSceneEvent.call(this.scene.oScene, eventParam);
        };
        // Legacy method... preserved for maintaining compatibility
        this.mousePressed = function() {
            this.handleEvent('mousePressed');
        };
        // Legacy method... preserved for maintaining compatibility
        this.keyPressed = function() {
            this.handleEvent('keyPressed');
        };
    }
}




var $25431021aafc01cf$exports = {};
$25431021aafc01cf$exports = new URL("RobotoCondensed-Light.a31380a2.ttf", import.meta.url).toString();


var $98613ceb8cab71dc$exports = {};
$98613ceb8cab71dc$exports = new URL("Railway.8fda91a1.ttf", import.meta.url).toString();


var $f7a920887b284dd8$exports = {};
$f7a920887b284dd8$exports = new URL("lobster-stamp.501387ff.png", import.meta.url).toString();



let $a5207cb3675fd5bf$var$modules = (parcelRequire("lf7DK"));
const $a5207cb3675fd5bf$var$API_ENDPOINT_ARTISTS = "/artists.php", $a5207cb3675fd5bf$var$API_ENDPOINT_CHARTS = "/charts.php", $a5207cb3675fd5bf$var$API_ENDPOINT_TIMELINE = "/timeline.php"; // eslint-disable-line no-undef
let $a5207cb3675fd5bf$var$scene;
let $a5207cb3675fd5bf$var$sceneFileName;
let $a5207cb3675fd5bf$var$allowCopyToClipboard = false;
async function $a5207cb3675fd5bf$export$bf184e22b30026c1(sceneFile) {
    $a5207cb3675fd5bf$var$sceneFileName = sceneFile;
    let sceneModule = await $a5207cb3675fd5bf$var$modules[sceneFile]();
    $a5207cb3675fd5bf$var$scene = sceneModule.default;
    let myp5 = new p5($a5207cb3675fd5bf$var$sketch, (0, $eWqok.getEl)('musipie')); // eslint-disable-line no-undef         
    return myp5;
}
function $a5207cb3675fd5bf$var$sketch(p) {
    class Artist {
        constructor(artist){
            this.name = artist.name;
            this.playcount = artist.playcount;
            this.streamsDaily = artist.streamsDaily;
            this.percent = artist.percent;
            this.mbid = artist.mbid;
        }
    }
    class Track {
        constructor(track){
            this.title = track.title.toUpperCase();
            this.artist = track.artist.toUpperCase();
            this.playcount = track.playcount;
        }
    }
    class Month {
        constructor(month){
            this.to = month.to;
            this.from = month.from;
            this.artists = [];
            if (typeof month.artists !== 'undefined') for (let artist of month.artists)this.artists.push(new Artist(artist));
        }
    }
    const SIDE_SHORT = 1152;
    const SIDE_LONG = 2048;
    let entries;
    let config = {
        WIDTH: SIDE_SHORT,
        HEIGHT: SIDE_LONG,
        allowCopyToClipboard: $a5207cb3675fd5bf$var$allowCopyToClipboard
    };
    p.preload = function() {
        $a5207cb3675fd5bf$var$loadConfig(config);
        config.fontBold = 'Arial';
        config.fontMono = 'Courier New';
        config.fontRegular = p.loadFont((0, (/*@__PURE__*/$parcel$interopDefault($25431021aafc01cf$exports))));
        let endpoint;
        // TODO: only load required fonts / images!
        switch($a5207cb3675fd5bf$var$sceneFileName.toLowerCase()){
            case 'underground':
                config.WIDTH = SIDE_LONG;
                config.HEIGHT = SIDE_SHORT;
                endpoint = $a5207cb3675fd5bf$var$API_ENDPOINT_TIMELINE;
                config.fontRailway = p.loadFont((0, (/*@__PURE__*/$parcel$interopDefault($98613ceb8cab71dc$exports))));
                break;
            case 'receipt':
                endpoint = $a5207cb3675fd5bf$var$API_ENDPOINT_CHARTS;
                config.lukeStamp = p.loadImage((0, (/*@__PURE__*/$parcel$interopDefault($f7a920887b284dd8$exports))));
                break;
            case 'piechart':
                endpoint = $a5207cb3675fd5bf$var$API_ENDPOINT_ARTISTS;
        }
        let url = [
            endpoint
        ];
        url.push("?");
        if (typeof config.userOpts.period !== 'undefined') url.push("period=", config.userOpts.period, "&");
        url.push("user=", config.userOpts.username);
        p.loadJSON(url.join(""), p.loadData, $a5207cb3675fd5bf$var$errorHandler);
    };
    p.loadData = function(data) {
        entries = [];
        // Check for errors
        if (data.error !== undefined || data.artists === undefined && data.tracks === undefined && data.months === undefined) {
            (0, $eWqok.showError)(data.message);
            (0, $eWqok.toggleLoading)(false);
            return;
        }
        config.lbf = data.lbf;
        config.totalStreams = data.playcount;
        config.days = data.days;
        config.username = data.username;
        // Artists
        if (data.artists) {
            entries.artists = [];
            for (let artist of data.artists)entries.artists.push(new Artist(artist));
        }
        // Tracks
        if (data.tracks) {
            entries.tracks = [];
            for (let track of data.tracks)entries.tracks.push(new Track(track));
        }
        // Months
        if (data.months) {
            entries.months = [];
            for (let month of data.months)entries.months.push(new Month(month));
        }
    };
    p.setup = function() {
        p.noLoop();
        p.pixelDensity(1);
        p.smooth();
        if (entries == null || entries.keys().length == 0) return;
        p.createCanvas(config.WIDTH, config.HEIGHT);
        config.entries = entries;
        var mgr = new (0, $7db3033d8052fb9b$export$39927d6faa7131bb)(p);
        mgr.config = config;
        mgr.wire();
        mgr.addScene($a5207cb3675fd5bf$var$scene);
        mgr.showNextScene();
    };
    p.downloadImage = function(button) {
        if ((0, $eWqok.isMobile)()) window.scrollTo({
            top: button.getBoundingClientRect().top + window.scrollY,
            behavior: 'instant'
        });
        this.save(config.username + '-' + $a5207cb3675fd5bf$var$sceneFileName.toLowerCase() + '-' + config.userOpts.data + '-' + config.userOpts.period + '.jpg');
        button.innerText = 'Downloading...';
        setTimeout(function() {
            button.innerHTML = 'Download image';
        }, 2000);
    };
    p.copyImage = function(button) {
        if ((0, $eWqok.isMobile)()) window.scrollTo({
            top: button.getBoundingClientRect().top + window.scrollY,
            behavior: 'instant'
        });
        document.getElementsByTagName('canvas')[0].toBlob(function(blob) {
            const item = new ClipboardItem({
                'image/png': blob
            });
            navigator.clipboard.write([
                item
            ]);
            button.innerText = 'Copied!';
            setTimeout(function() {
                button.innerHTML = 'Copy to clipboard';
            }, 2000);
        });
    };
    p.updateConfig = function() {
        $a5207cb3675fd5bf$var$loadConfig(config);
        p.setup();
        p.draw();
        if ((0, $eWqok.isMobile)()) (0, $eWqok.getEl)('musipie').scrollIntoView(true);
        else (0, $eWqok.getEl)('headline').scrollIntoView(true);
    };
    p.finishLoading = function() {
        if ((0, $eWqok.getEl)('loader').style.display == 'none') return;
        (0, $eWqok.getEl)('usernameForm').style.display = 'none';
        (0, $eWqok.getEl)('currentUser').style.display = 'block';
        const musipie = (0, $eWqok.getEl)('musipie');
        musipie.className = 'fadeIn';
        (0, $ce69c7c7f1b67752$export$88581142a70e5f2a)(config.recommendation);
        (0, $eWqok.toggleLoading)(false);
        (0, $eWqok.getEl)('resultWrap').style.display = 'block';
        if ((0, $eWqok.isMobile)()) (0, $eWqok.getEl)('musipie').scrollIntoView(true);
        else (0, $eWqok.getEl)('headline').scrollIntoView(true);
    };
}
function $a5207cb3675fd5bf$var$loadConfig(config) {
    config.userOpts = (0, $480eb26aa317c74a$export$c39d60ad3836980e)();
    let errors = (0, $480eb26aa317c74a$export$21565defcc82432b)(config.userOpts);
    (0, $eWqok.invalidateFields)(errors);
    if (Object.keys(errors).length > 0) {
        (0, $eWqok.toggleLoading)(false);
        return;
    }
    (0, $480eb26aa317c74a$export$57da33ee5a3f2b7e)(config.userOpts);
    (0, $eWqok.getEl)('userPlaceholder').innerText = config.userOpts.username;
}
function $a5207cb3675fd5bf$var$errorHandler(err) {
    (0, $eWqok.showError)(typeof err == 'string' ? err : 'An error occured while trying to load your data.');
    (0, $eWqok.toggleLoading)(false);
}


"use strict";
let $54b47fc030b7b21e$var$sceneFile;
window.onload = function() {
    function reloadChart(initialLoad) {
        if (initialLoad) (0, $eWqok.getEl)('resultWrap').style.display = 'none';
        (0, $eWqok.resetErrors)();
        (0, $eWqok.getEl)('rec').className = 'fadeOut';
        const musipie = (0, $eWqok.getEl)('musipie');
        musipie.className = 'fadeOut';
        while(musipie.firstChild)musipie.removeChild(musipie.firstChild);
        $54b47fc030b7b21e$var$sceneFile = (0, $eWqok.getEl)('scene').value;
        (0, $eWqok.toggleLoading)(true);
        myp5 = (0, $a5207cb3675fd5bf$export$bf184e22b30026c1)($54b47fc030b7b21e$var$sceneFile);
    }
    // Only on pages with a form
    if ((0, $eWqok.getEl)('submit') == null) return;
    // Setup palette modal
    (0, $g4wOo.setupPalette)();
    (0, $ce69c7c7f1b67752$export$f8d9bf6a7c6cbe5f)();
    // Setup modal buttons    
    document.querySelectorAll('a[data-target],button[data-target]').forEach((item)=>{
        item.addEventListener('click', (event)=>{
            (0, $lvhTS.toggleModal)(event);
        });
    });
    // Get options from cookie
    let userOpts = (0, $480eb26aa317c74a$export$5f3afe997a31b314)();
    let autostart = false;
    if (userOpts) {
        let errors = (0, $480eb26aa317c74a$export$21565defcc82432b)(userOpts);
        (0, $eWqok.invalidateFields)(errors);
        if (Object.keys(errors).length == 0) {
            autostart = true;
            (0, $480eb26aa317c74a$export$d063a043038816d5)(userOpts);
        }
    }
    let myp5;
    window.focus();
    navigator.permissions.query({
        name: 'clipboard-write'
    }).then((result)=>{
        if (result.state == 'granted' || result.state == 'prompt') (0, $eWqok.getEl)('buttonClipboard').style.display = 'block';
    });
    (0, $eWqok.getEl)('submit').addEventListener('click', function() {
        reloadChart(true);
    }, false);
    (0, $eWqok.getEl)('buttonDownload').addEventListener('click', (e)=>{
        myp5.then((m)=>m.downloadImage(e.target));
    }, false);
    (0, $eWqok.getEl)('logoutLink').addEventListener('click', ()=>{
        (0, $480eb26aa317c74a$export$b43e45590305ffaa)();
        (0, $eWqok.getEl)('currentUser').style.display = 'none';
        (0, $eWqok.getEl)('resultWrap').style.display = 'none';
        (0, $eWqok.getEl)('usernameForm').style.display = 'block';
    }, false);
    (0, $eWqok.getEl)('buttonClipboard').addEventListener('click', (e)=>{
        myp5.then((m)=>m.copyImage(e.target));
    }, false);
    // Watch for form changes
    document.querySelectorAll('.changeListener').forEach((item)=>{
        item.addEventListener('change', (e)=>{
            if (typeof myp5 === 'undefined') return;
            if (e.target.id == 'period' || e.target.name == 'data' || e.target.id == 'intFont') reloadChart(false);
            else myp5.then((m)=>m.updateConfig());
        }, false);
    });
    window.addEventListener('blur', ()=>{
        setTimeout(()=>{
            if (document.activeElement.tagName === 'IFRAME') umami.track(document.activeElement.id + ' embed'); // eslint-disable-line no-undef
        });
    }, {
        once: true
    });
    if (autostart) reloadChart(true);
};


//# sourceMappingURL=index.744589b5.js.map
